import { createClient } from "contentful";

export default createClient({
  space: "bkegovtlyyd6",
  accessToken: "K_oabpGE2Qb02cCv-b_-aCEIQgeoLRsj3UTyGQL9Z-Y",
});
